<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top  navbar-expand"
    type=""
  >
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler sidenav-toggler-dark" v-show="companyHasSite"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!--
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li> -->
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
                  <span class="others others-sm">
                    <img alt="Image placeholder" src="/img/theme/others_menu.svg">
                  </span>
          </div>
        </a>
        <template>
          <!-- List group -->
          <div class="list-group list-group-flush floating-menu"> 
            <a href="/terms" class="dropdown-item">
              <span>利用規約</span>
            </a>
            <a href="/browser-support" class="dropdown-item">
              <span>サポートブラウザ</span>
            </a>
            <a href="/manual" target="_blank" class="dropdown-item">
              <span>マニュアル</span>
              <i class="fas fa-external-link-alt"></i>
            </a>
            <a href="/contact" target="_blank" class="dropdown-item">
              <span>お問い合わせ</span>
              <i class="fas fa-external-link-alt"></i>
            </a>
          </div>
        </template>
      </base-dropdown>
    </ul>
   <ul class="navbar-nav align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
                  <span class="avatar avatar-sm rounded-circle">
                    <img alt="Image placeholder" src="/img/theme/user.svg">
                  </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{ userData.name }}</span>
            </div>
            
          </div>
        </a>

        <template>

          <a href="/profile" class="dropdown-item">
            <i class="ni"></i>
            <span>アカウント情報</span>
          </a>
          <a href="/profile/password" class="dropdown-item">
            <i class="ni"></i>
            <span>パスワード変更</span>
          </a>
          
          <a href="/contract/" class="dropdown-item" v-show="showContractMenu">
            <i class="ni"></i>
            <span>契約情報</span>
          </a>
          

          <div class="dropdown-divider"></div>
          <a href="#!" class="dropdown-item" @click.prevent="logout">
            <i class="ni"></i>
            <span>ログアウト</span>
          </a>
          
        <form id="logout-form" action="logout" method="POST" style="display: none;">
          <input type="hidden" name="_token" :value="csrf">
        </form>

        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
  import { BaseNav } from '../argonComponents';

  export default {
    components: {
      BaseNav
    },
    props: {
      userData: {
        type: Object,
      },
    },
    computed: {
      isRTL() {
        return this.$rtl.isRTL;
      }
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: true,
        companyHasSite:false,
        searchModalVisible: false,
        searchQuery: '',
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        userId:null,
        showContractMenu : false
      };
    },
    mounted() {
      this.userId = window.PushL.user.id
      const permission = window.PushL.permission_list
      this.companyHasSite = window.PushL.company_has_site
      this.showContractMenu = permission['plan-edit'];
     
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
       
      logout(evt) {
       if(confirm("本当にログアウトしますか?")) {
       document.getElementById('logout-form').submit();   
       }
     },
    }

    /*

    <a href="{{ url('/logout') }}"
                                            onclick="event.preventDefault();
                                                     document.getElementById('logout-form').submit();">
                                            Logout
                                        </a>

                                        <form id="logout-form" action="{{ url('/logout') }}" method="POST" style="display: none;">
                                            {{ csrf_field() }}
                                        </form>

    */
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
</style>
